module.exports = __webpack_public_path__ + "img/9.1-gallery.092ffb98.jpg";